import { render, staticRenderFns } from "./body.vue?vue&type=template&id=7712c0c1&scoped=true"
import script from "./body.vue?vue&type=script&lang=js"
export * from "./body.vue?vue&type=script&lang=js"
import style0 from "./body.vue?vue&type=style&index=0&id=7712c0c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7712c0c1",
  null
  
)

export default component.exports